export default __webpack_public_path__ + "static/article-new-alternatives-to-credit-cards-d4cacb53959f145eb55ade19b450785e.jpg";